

import moment from 'moment';

export default {
  name: "monitoramento-table",
  components: {

  },

    props: {
      rotas: {
        type: Array,
        default: () => {
          [];
        },
      },
      map: {
        type: Object,
        default: () => {
          return {}; // Retorna um objeto vazio como valor padrão
        },
      },
    },
    methods: {
      closeAll() {
        //this.rotas.forEach((item) => (item.open = false));
      },
      fDate(date:any){
          return moment(date).format('H') + 'h';
      },
    },

    data() {
      return {
        por_pagina : false,
        isLast: false,
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const setCenter = (rota: any) => {
        if (rota.Operacao && rota.Operacao.latitude && rota.Operacao.longitude) {
          const newLocation = {
            lat: parseFloat(rota.Operacao.latitude),
            lng: parseFloat(rota.Operacao.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      const setCenterItem = (pedido: any) => {
        if (pedido.latitude && pedido.longitude) {
          const newLocation = {
            lat: parseFloat(pedido.latitude),
            lng: parseFloat(pedido.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };


      const  getRotaClassByStatus = (status:Number) => {
        if (status === 0) return 'pedido-desativado'; // Pedido desativado
        if (status === 1) return 'entregue';     // Pedido ativo
        if (status === 2) return 'pedido-ativo'; // Pedido concluído
        return '';
      }

      const  getClassByStatus = (status:Number) => {
        if (status === 0) return 'pedido-desativado'; // Pedido desativado
        if (status === 1) return 'pedido-ativo';     // Pedido ativo
        if (status === 2) return 'pedido-concluido'; // Pedido concluído
        return '';
      }

      const calculaConclusao= (pedidos:any) => {

        const totalPedidos      = pedidos.length;
        const pedidosConcluidos = pedidos.filter((p:any) => p.status_entrega === 2).length;
        const percentualConclusao = totalPedidos > 0 ? Math.round((pedidosConcluidos / totalPedidos) * 100) : 0;


        const color = percentualConclusao > 80 ? 'success':percentualConclusao>40?'warning':'danger'

        return (`<span   class="badge bg-gradient-${color}" >${percentualConclusao}%</span>`);

     }
      // Retorna os métodos ou variáveis que você quer expor
      return {
        getClassByStatus,
        getRotaClassByStatus,
        setCenter,
        setCenterItem,
        calculaConclusao
      };
    }
};
